/**
 * Les chemins de la console.
 *
 * Ils vivent ici et non dans `lib/chemins.ts` : ce fichier-là appartient à la
 * fondation et décrit les espaces d'un THÉÂTRE. La console est servie depuis
 * une autre origine et n'a aucun chemin en commun avec eux — y ajouter ses
 * constantes créerait un conflit de fusion pour des valeurs que le back-office
 * n'utilisera jamais.
 *
 * ★ La console occupe la **racine** de son hôte (`/`, `/tenants`, …), pas un
 *   préfixe `/console`. Le sous-domaine EST le préfixe : le répéter dans le
 *   chemin donnerait `console.ticket.ilygo.ch/console/tenants`, qui se lit comme
 *   un bégaiement et n'achète rien.
 */

export const CHEMINS_CONSOLE = {
  racine: '/',
  connexion: '/connexion',
  tenants: '/tenants',
  creation: '/tenants/nouveau',
  tenant: (slug: string) => `/tenants/${slug}`,
  paiementsTenant: (slug: string) => `/tenants/${slug}/paiements`,
  walletTenant: (slug: string) => `/tenants/${slug}/wallet`,
  smsTenant: (slug:string)=>`/tenants/${slug}/sms`,
  crmTenant: (slug:string)=>`/tenants/${slug}/crm`,
  moyensPaiement: '/moyens-paiement',
  sante: '/sante',
  sauvegardes: '/sauvegardes',
  sauvegardeTenant: (slug: string) => `/sauvegardes/${slug}`,
  statistiques: '/statistiques',
  journal: '/journal',
  bascule: '/bascule',
  superadmins: '/superadmins',
  securite: '/securite',
} as const
